export default __webpack_public_path__ + "static/aws-data-lake-event-management-solutions-6ec4971feec6efd3ca67a17dc95fbd26.png";